import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { IncidentSeverity, IncidentStatus, selectAllIncidentCategories } from '@tokeet-frontend/incident'
import { AutomationAttachmentsDataBaseComponent } from '@tv3/containers/automations/automation-data-form/automation-attachments-data-base.component'
import { select, Store } from '@ngrx/store'
import { AttachmentService, notAllNumbersValidator, selectAllUsers } from '@tokeet-frontend/tv3-platform'
import { AuthService } from '@tv3/services/auth.service'

export function createAutomationIncidentDataForm(fb: FormBuilder, isReporterRequired = true) {
  return fb.group({
    title: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), notAllNumbersValidator]],
    categories: [[], [Validators.required]],
    description: ['', [Validators.maxLength(500)]],
    status: [IncidentStatus.Open],
    severity: [IncidentSeverity.Medium],
    reporter_id: ['', isReporterRequired ? [Validators.required] : []],
    reviewer_id: [],
    images: [],
    tags: [[]],
  })
}

@Component({
  selector: 'app-automation-incident-data-form',
  templateUrl: './automation-incident-data-form.component.html',
  styleUrls: ['./automation-incident-data-form.component.scss'],
})
export class AutomationIncidentDataFormComponent extends AutomationAttachmentsDataBaseComponent implements OnInit {
  @Input() form: FormGroup
  @Input() hideReporterField = false

  get attachmentsCtrl(): FormControl {
    return this.form.get('images') as FormControl
  }

  users$ = this.store.pipe(select(selectAllUsers))
  statuses = Object.values(IncidentStatus)
  severities = Object.values(IncidentSeverity)
  categories$ = this.store.pipe(select(selectAllIncidentCategories))

  constructor(
    protected store: Store<any>,
    protected authService: AuthService,
    protected attachmentService: AttachmentService
  ) {
    super(store, authService, attachmentService)
  }

  ngOnInit(): void {
    super.ngOnInit()
  }
}
